export default __webpack_public_path__ + "static/media/avvatar1.6ccd76c6.jpg";